import { createFileRoute } from "@tanstack/react-router"

import { breadcrumbJsonLd, buildHead } from "@/core/seo"

import { ProductPage } from "../components/landing"
import { MILEAGE_TRACKER, MILEAGE_SEO } from "../content/products/mileage-tracker"

/** Breadcrumb JSON-LD only: SoftwareApplication/Offer wait for final prices and reviews (copy-products.md). */
export const mileageTrackerSeo = () =>
  buildHead({
    ...MILEAGE_SEO,
    path: MILEAGE_TRACKER.path,
    jsonLd: [breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: MILEAGE_TRACKER.name }])],
  })

export const Route = createFileRoute("/_brand-layout/mileage-tracker")({
  head: () => {
    const { meta, links, scripts } = mileageTrackerSeo()
    return { meta, links, scripts }
  },
  component: MileageTrackerPage,
})

export function MileageTrackerPage() {
  return <ProductPage content={MILEAGE_TRACKER} />
}
